import PresortDemo from "../components/table/DataTable";
import React, { useEffect, useRef, useState } from "react";
import { useGetUsersQuery, useCreateUserMutation, useSendUserWhatsappMutation } from "../store/api/userAPI"
import { Sidebar } from "primereact/sidebar";
import { userForWareColumn } from "../metadata/user";
import "./page.css"
import Editor from "../components/UI/editor";
import { SpeedDial } from "primereact/speeddial";
import { useActionsHook } from "../hooks/useActionsHook";
import MyButton from "../components/UI/Button";
import { Toast } from "primereact/toast";
import JsBarcode from "jsbarcode";
function UserForWarehouse() {
	const toast = useRef(null);
	const barcodeRef = React.useRef();
	const [selectedProducts, setSelectedProducts] = useState(null);
	const [searchForm, setSearchForm] = useState({});
	const scanEditor = useRef({});
	const handlePrint = (e, data) => {
		setTimeout(() => {
			const win = window.open("", "", "height=300,width=600");
			win.document.write("<html><head><title>Print</title></head><body>");
			win.document.write(`<p>${data.client_code}</p>`);
			win.document.write("</body></html>");
			win.document.close();
			win.focus();
			win.print();
			win.close();
		}, 100);
	};
	const actions = useActionsHook([
		{
			onClick: handlePrint,
			icon: "pi pi-print"
		}
	])
	const [visibleLeft, setVisibleLeft] = useState({ visible: false, data: null });
	const { data, error, isLoading } = useGetUsersQuery(
		{
			search: searchForm?.email
		}
	);



	const onSearchBlur = (e, attr, value) => {
		setSearchForm(state => ({ ...state, [attr]: value }))
	}




	return (<>
		<div ref={barcodeRef} style={{ display: "none" }}>
			<svg id="barcode"></svg>
		</div>
		<Toast ref={toast} />
		<div className="" style={{ width: "360px", padding: "8px" }}>
			<Editor onBlur={onSearchBlur} data={searchForm} attr="email" placeholder="Поиск по email, номер, фио" trim refEl={scanEditor} />
		</div>

		<PresortDemo
			selection={selectedProducts}
			selectionMode="multiple"
			onSelectionChange={(e) => setSelectedProducts(e.value)}
			isLoading={isLoading}
			data={data?.data}
			paginator={true}
			scrollHeight="calc(100vh - 160px)"
			column={userForWareColumn ?? Object.keys(data.data[0])}
			toggleSidebar={() => { }}
			actions={actions} />
	</>);
}
export default UserForWarehouse;